<template>
    <div class="subtitles">
        <div class="zimu-wrap" ref="zimuWrap">
            <div v-for="(item, index) in zimuList" :key="index" :class="{ active: activeIndex === index }"
                class="textBox" ref="zimuItems">
                <!-- <span class="typewriter-text"> -->
                {{ item.content }}
                <!-- </span> -->
            </div>
        </div>
        <van-empty v-if="!zimuList.length" description="" image-size="145"
            image="https://cdn.edstatic.com/203012120000/2d577795d2314218ad6acea93e649408/2025/07/34459370-fafb-4bb9-9242-5f85747b8d88.png">
            <p style="text-align: center;color: #6E7176;">请点击日程<br>
                方可查看日程字幕</p>
        </van-empty>

    </div>

</template>
<script>
export default {
    props: ['zimuList', "lang"],
    data() {
        return {
            activeIndex: -1,
            currentTime: 0,
            displayTexts: [], // 用于存储每项字幕的逐字显示内容
            animationIntervals: [], // 存储动画定时器
            lastScrollTop: 0 // 记录上次滚动位置
        }
    },
    watch: {
        zimuList(newVal, oldVal) {
            // 停止所有现有动画
            // this.clearAllAnimations();
            // 滚动到最新字幕
            this.$nextTick(() => {
                this.scrollToLatest();
            });
        },
        currentTime(newTime) {
            const currentIndex = this.zimuList.findIndex(item =>
                newTime >= item.start_at && newTime <= item.end_at
            );
            this.activeIndex = currentIndex;
        }
    },
    beforeDestroy() {
        this.clearAllAnimations();
    },
    mounted() {
        // 开始模拟视频播放（实际应替换为真实视频事件）
        // this.startPlayback();
    },
    methods: {
        // 启动文本逐字动画
        startTextAnimation(text, index) {
            this.stopAnimation(index); // 先停止现有动画

            const characters = text.split('');
            let currentChar = 0;

            this.animationIntervals[index] = setInterval(() => {
                if (currentChar < characters.length) {
                    this.$set(this.displayTexts, index,
                        this.displayTexts[index] + characters[currentChar]);
                    currentChar++;

                    // 每显示10个字符检查是否需要滚动
                    if (currentChar % 10 === 0) {
                        this.scrollToLatest();
                    }
                } else {
                    this.stopAnimation(index);
                }
            }, 50); // 每个字符间隔50ms
        },

        // 停止指定索引的动画
        stopAnimation(index) {
            if (this.animationIntervals[index]) {
                clearInterval(this.animationIntervals[index]);
                this.$set(this.animationIntervals, index, null);
            }
        },

        // 停止所有动画
        clearAllAnimations() {
            this.animationIntervals.forEach((interval, index) => {
                this.stopAnimation(index);
            });
        },


        backBottom() {
            let ele = this.$refs.mesContainer;
            let scrollTop = 0;
            this.$nextTick(() => {
                if (ele.scrollHeight > ele.clientHeight) {
                    scrollTop = ele.scrollHeight - ele.clientHeight + 44;
                    this.$refs.mesContainer.scrollTop = scrollTop;
                }
            })
        },


        // 滚动到最新字幕
        scrollToLatest() {
            if (!this.zimuList.length || !this.$refs.zimuItems) return;
            const lastIndex = this.zimuList.length - 1;
            const lastItem = this.$refs.zimuItems[lastIndex];

            if (lastItem) {
                lastItem.scrollIntoView({
                    behavior: 'smooth',
                    block: "end"
                });
            }
        }

    }
}
</script>
<style lang="scss" scoped>


.zimu-wrap {
    color: #3D3D3D;
    padding: 15px 15px;
    // overflow-y: auto; // 允许垂直滚动
    overflow-x: hidden;
    scroll-behavior: smooth; // 平滑滚动
    // position: absolute;
    // top: 0;
    // bottom:0px;
    width: 100%;


    div {
        margin-bottom: 10px;
    }
}

.typewriter-text {
    display: inline-block;
}

.textBox {
    position: relative;
    display: inline-block;
    font-size: 14px;

    &.active::after {
        content: '|';
        position: absolute;
        right: -5px;
        animation: blink 0.7s infinite;
        color: #1989FA;
    }
}

@keyframes blink {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

.van-empty__bottom {
    margin-top: 0;
}

.subtitle-item {
    position: relative;
    padding: 5px 0;
    transition: all 0.3s ease;

    // 默认样式
    &::before {
        content: '';
        position: absolute;
        left: -10px;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 4px;
        background: #3D3D3D;
        border-radius: 50%;
        opacity: 0.5;
    }

    // 高亮样式
    &.active {
        color: #1989FA; // 高亮颜色
        font-weight: bold;

        &::before {
            width: 8px;
            height: 8px;
            background: #1989FA;
            opacity: 1;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Meeting/Zimu.vue